module.exports = __webpack_public_path__ + "img/46.95ed9f1d.webp";